"use strict";
// Generated from splitscript/antlr_files/Splitscript.g4 by ANTLR 4.13.1
Object.defineProperty(exports, "__esModule", { value: true });
const antlr4_1 = require("antlr4");
/**
 * This interface defines a complete generic visitor for a parse tree produced
 * by `SplitscriptParser`.
 *
 * @param <Result> The return type of the visit operation. Use `void` for
 * operations with no return type.
 */
class SplitscriptVisitor extends antlr4_1.ParseTreeVisitor {
    /**
     * Visit a parse tree produced by `SplitscriptParser.program`.
     * @param ctx the parse tree
     * @return the visitor result
     */
    visitProgram;
    /**
     * Visit a parse tree produced by `SplitscriptParser.formula`.
     * @param ctx the parse tree
     * @return the visitor result
     */
    visitFormula;
    /**
     * Visit a parse tree produced by the `exprAtom`
     * labeled alternative in `SplitscriptParser.expr`.
     * @param ctx the parse tree
     * @return the visitor result
     */
    visitExprAtom;
    /**
     * Visit a parse tree produced by the `exprPlusMinus`
     * labeled alternative in `SplitscriptParser.expr`.
     * @param ctx the parse tree
     * @return the visitor result
     */
    visitExprPlusMinus;
    /**
     * Visit a parse tree produced by the `exprBoolean`
     * labeled alternative in `SplitscriptParser.expr`.
     * @param ctx the parse tree
     * @return the visitor result
     */
    visitExprBoolean;
    /**
     * Visit a parse tree produced by the `exprComparison`
     * labeled alternative in `SplitscriptParser.expr`.
     * @param ctx the parse tree
     * @return the visitor result
     */
    visitExprComparison;
    /**
     * Visit a parse tree produced by the `exprPow`
     * labeled alternative in `SplitscriptParser.expr`.
     * @param ctx the parse tree
     * @return the visitor result
     */
    visitExprPow;
    /**
     * Visit a parse tree produced by the `exprTimesDiv`
     * labeled alternative in `SplitscriptParser.expr`.
     * @param ctx the parse tree
     * @return the visitor result
     */
    visitExprTimesDiv;
    /**
     * Visit a parse tree produced by the `exprParenthesis`
     * labeled alternative in `SplitscriptParser.expr`.
     * @param ctx the parse tree
     * @return the visitor result
     */
    visitExprParenthesis;
    /**
     * Visit a parse tree produced by the `exprSignedAtom`
     * labeled alternative in `SplitscriptParser.expr`.
     * @param ctx the parse tree
     * @return the visitor result
     */
    visitExprSignedAtom;
    /**
     * Visit a parse tree produced by `SplitscriptParser.atom`.
     * @param ctx the parse tree
     * @return the visitor result
     */
    visitAtom;
}
exports.default = SplitscriptVisitor;
